import { defineStore } from "pinia";

export const useRootStore = defineStore("Hyp-Frontend", {
  state: () => ({
    loginStore: useLoginStore().$state,
    userStore: useUserStore().$state,
    homeStore: useHomeStore().$state,
    rewardsStore: useRewardsStore().$state,
    cartStore: useCartStore().$state,
    errorStore: useErrorStore().$state,
    checkoutStore: useCheckoutStore().$state,
    orderStore: useOrderStore().$state,
    pointStore: usePointStore().$state,
    appstarted: false,
  }),
  actions: {
    setAppStart(payload: boolean) {
      this.appstarted = payload;
    },
    clearStore() {
      useLoginStore().clearLoginTypeData();
      useUserStore().clearUserStore();
      useHomeStore().clearHomePageData();
      useErrorStore().clearErrorStore();
      useRewardsStore().clearRewards();
      useCheckoutStore().clearCheckoutData();
      useOrderStore().clearOrderStore();
      useCartStore().clearCart();
      usePointStore().clearPayload();
      this.appstarted = false;
    },
  },
  persist: {
    key: "HYP-Frontend",
  },
});
